import { useMemo, useState } from "react";
import ShopProductFilters from "./ShopProductFilters";
import { stockAvailability } from "../utils/stockAvailability";
import { defaultShopProductFilters, filterShopProducts, shopProductCategories } from "../utils/shopProductFilters";

function ShopStorefrontPreview({ listings, mediaUrl, onOpenListing, shop }) {
  const activeListings = listings.filter((listing) => listing.status === "active");
  const [filters, setFilters] = useState(defaultShopProductFilters);
  const categories = useMemo(() => shopProductCategories(activeListings), [activeListings]);
  const visibleListings = useMemo(() => filterShopProducts(activeListings, filters), [activeListings, filters]);
  const shopName = shop?.shop_name || "Din butik";
  const logoUrl = shop?.shop_logo_url ? mediaUrl(shop.shop_logo_url) : "";
  const coverUrl = shop?.cover_url ? mediaUrl(shop.cover_url) : "";

  return (
    <section className="storefront-preview" style={{ "--shop-color": shop?.shop_color || "#1f6f5f" }}>
      {coverUrl && <img className="storefront-cover" src={coverUrl} alt="" />}
      <header className="storefront-header">
        {logoUrl ? <img src={logoUrl} alt={`${shopName} logo`} /> : <div className="shop-logo-placeholder">Logo</div>}
        <div><span>{shop?.owner_type === "business" ? "Virksomhed" : "Mini shop"}</span><h2>{shopName}</h2><p>{shop?.description || `${activeListings.length} aktive varer`}</p></div>
      </header>
      {activeListings.length ? <ShopProductFilters categories={categories} filters={filters} onChange={setFilters} onReset={() => setFilters(defaultShopProductFilters)} resultCount={visibleListings.length} /> : null}
      {visibleListings.length ? (
        <div className="storefront-products">
          {visibleListings.map((listing, index) => {
            const availability = stockAvailability(listing.inventory_count);
            const ProductContainer = onOpenListing ? "button" : "article";
            return <ProductContainer
              className="storefront-product-card"
              key={listing.id}
              onClick={onOpenListing ? () => onOpenListing(listing, index) : undefined}
              type={onOpenListing ? "button" : undefined}
            >
              {listing.primary_image_url ? <img src={mediaUrl(listing.primary_image_url)} alt="" /> : <div className="storefront-image-placeholder">Intet billede</div>}
              <div><strong>{listing.title}</strong><span>{listing.price_amount} {listing.price_currency}</span>{availability && <small className={`stock-label ${availability.level}`}>{availability.label}</small>}</div>
            </ProductContainer>;
          })}
        </div>
      ) : <div className="empty-results">{activeListings.length ? "Ingen varer matcher din søgning og dine filtre." : "Butikken har ingen aktive varer endnu."}</div>}
    </section>
  );
}

export default ShopStorefrontPreview;
